// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__T0Eoq","productName":"Table_productName__2-bCF"};